require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eventi-a-historical-critical-guide-to-20th-century-architecture-in-canton-ticino-vol-i.json") })
        }
      }, "path---eventi-a-historical-critical-guide-to-20th-century-architecture-in-canton-ticino-vol-i");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eventi-a-historical-critical-guide-to-20th-century-architecture-in-canton-ticino-vol-i!./.cache/json/eventi-a-historical-critical-guide-to-20th-century-architecture-in-canton-ticino-vol-i.json
// module id = 651
// module chunks = 231608221292675